export * from './lib/google-places-autocomplete/google-places-autocomplete.component';
